import { UserHeaderComponent } from "./user-header.component";
export var UserHeaderModule = angular
    .module('userHeader', [])
    .component(UserHeaderComponent.selector, UserHeaderComponent.component)
    .name;
//# sourceMappingURL=user-header.module.js.map